import googleAnalytics from './GoogleAnalytics';

export { default as AnalyticAttrsCtx } from './AnalyticAttrsCtx';
export { Action, Category, Label } from './constants';
export { useAnalyticAttrs } from './hooks';
export type {
    AnalyticAttrs,
    Analytics,
    FieldsObj,
    RequiredAnalytics,
} from './types';
export { formatPathname, formatSearch } from './utils';

export default googleAnalytics;
